<template>
  <div v-if="isMounted" :key="settings.icon" class="loader vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
    <statistics-card-line 
      hideChart
      class="mb-base "
      icon-right
      :icon="settings.icon" 
      :statistic="settings.value"
      :statisticTitle="settings.label"
    />
  </div>
</template>

<script>
import StatisticsCardLine from "./StatisticsCardLine.vue";
export default {
  data() {
    return {
      isMounted: false
    };
  },
  components: {
    StatisticsCardLine
  },
  props: {
    settings: Object,
    default: {}
  },
  created() {
    this.isMounted = true;
  }
};
</script>